var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-16 -164)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 45,
    height: 45,
    rx: 5,
    transform: "translate(16 164)",
    fill: "#0890f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21443",
    "data-name": "Group 21443",
    transform: "translate(-16 71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27141",
    "data-name": "Path 27141",
    d: "M83.11,19.7c.452-.245.763-.6.645-1.075a5,5,0,0,0-.6-1.113c.969-.765,1.076-1.279.426-2.077.449-.169.886-.327,1.319-.5a1.284,1.284,0,0,0,.816-1.633,1.689,1.689,0,0,0-.268-.472c-.591-.765-1.183-1.528-1.791-2.28a2.83,2.83,0,0,1-.635-1.78A8.847,8.847,0,0,0,76.394.312,8.705,8.705,0,0,0,74.3.021,23.893,23.893,0,0,0,70.4.143a8.967,8.967,0,0,0-7.618,6.5,9.71,9.71,0,0,0,2.586,10.43,5.08,5.08,0,0,1,1.42,4.932c-.078.356-.171.708-.258,1.062A2.413,2.413,0,0,0,68.84,26.2c1.954.1,3.909.182,5.863.271.472.022.945.052,1.418.063a2.417,2.417,0,0,0,2.63-2.268c.016-.128.028-.257.056-.382a.782.782,0,0,1,.946-.651c.582.1,1.162.211,1.742.322a1.978,1.978,0,0,0,2.46-1.658,1.889,1.889,0,0,0-.285-1.292c-.177-.293-.359-.582-.56-.906m-.365-.978L82.3,18.9c-.5.2-.6.493-.311.956.27.439.547.873.814,1.314a.92.92,0,0,1-.961,1.393c-.666-.12-1.329-.254-2-.357a1.816,1.816,0,0,0-2.056,1.478c-.046.253-.067.511-.123.762a1.345,1.345,0,0,1-1.293,1.059c-.193,0-.387,0-.58-.014q-2.739-.125-5.477-.254c-.558-.026-1.121-.028-1.672-.1A1.353,1.353,0,0,1,67.5,23.462c.078-.356.172-.708.257-1.063a6.031,6.031,0,0,0-1.631-6.013,8.819,8.819,0,0,1-2.645-8.4A8.218,8.218,0,0,1,69,1.519a13.137,13.137,0,0,1,6.288-.369,7.741,7.741,0,0,1,6.7,7.642,3.862,3.862,0,0,0,.878,2.431c.589.725,1.16,1.465,1.735,2.2.243.31.2.446-.171.589-.642.245-1.287.481-1.927.728-.54.208-.612.617-.183,1.005.2.183.407.362.625.556-.322.286-.607.531-.882.786a.534.534,0,0,0-.039.864c.228.255.465.5.717.772",
    transform: "translate(-22.226 102)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27142",
    "data-name": "Path 27142",
    d: "M2.781,156.647a6.6,6.6,0,0,0-1.85-4.567.519.519,0,0,0-.666-.14.456.456,0,0,0-.25.54.792.792,0,0,0,.187.327,5.488,5.488,0,0,1,0,7.671.536.536,0,0,0-.043.8.52.52,0,0,0,.79-.091,6.569,6.569,0,0,0,1.833-4.535",
    transform: "translate(66.134 -36.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27143",
    "data-name": "Path 27143",
    d: "M22.918,169.862a4.689,4.689,0,0,0-1.317-3.253.516.516,0,0,0-.886.055.566.566,0,0,0,.169.693,3.605,3.605,0,0,1,1,2.31,3.649,3.649,0,0,1-.934,2.721c-.354.4-.4.674-.129.913s.56.163.9-.228a4.745,4.745,0,0,0,1.2-3.212",
    transform: "translate(44.222 -50.074)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27144",
    "data-name": "Path 27144",
    d: "M43.777,183.748a3.28,3.28,0,0,0-.661-1.756,1.036,1.036,0,0,0-.289-.251.508.508,0,0,0-.675.745,3.891,3.891,0,0,1,.512.913,1.773,1.773,0,0,1-.422,1.733c-.24.278-.269.535-.1.75a.521.521,0,0,0,.813-.006,3.01,3.01,0,0,0,.819-2.128",
    transform: "translate(21.523 -64.028)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup24);
export default __webpack_public_path__ + "static/media/Group 24.19d99cfa3a22d749a7a21464f6513d9e.svg";
export { ForwardRef as ReactComponent };